import { accountBadgeDistributionStatuses, accountBadgeStatuses } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { useAccountFilterConfig } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountsFilterConfig';
export function useAccountBadgeFilterConfig(defaultAdvancedSearchItems, extendFilters) {
    const { t } = useBadgingTranslation();
    const extendAccountFilters = (builder) => {
        builder.quickFilterMultiSelect({
            label: t(`badges.badgeDetails.accountBadgeTable.filterLabels.status`),
            dataPath: 'status',
            widget: 'form.checkboxList',
            values: accountBadgeStatuses.map((accountBadgeStatus) => ({
                value: accountBadgeStatus,
                label: t(`badges.badgeDetails.statuses.${accountBadgeStatus}`),
            })),
        });
        builder.quickFilterMultiSelect({
            label: t(`badges.badgeDetails.accountBadgeTable.filterLabels.distribution`),
            dataPath: 'distributionStatus',
            widget: 'form.checkboxList',
            values: accountBadgeDistributionStatuses.map((accountBadgeDistributionStatus) => ({
                value: accountBadgeDistributionStatus,
                label: t(`badges.badgeDetails.distributionStatuses.${accountBadgeDistributionStatus}`),
            })),
        });
        builder.quickDateRangeFilter({
            label: t(`badges.badgeDetails.accountBadgeTable.filterLabels.expirationDate`),
            dataPath: 'expiresAt',
        });
        extendFilters === null || extendFilters === void 0 ? void 0 : extendFilters(builder);
    };
    const filterConfig = useAccountFilterConfig({
        advancedSearchItems: defaultAdvancedSearchItems,
        showAccountSystemRoleFilter: 'onlyAllFiltersPanel',
        showAccountStatusFilter: 'onlyAllFiltersPanel',
        extendFilters: extendAccountFilters,
    });
    return filterConfig;
}
